export default __webpack_public_path__ + "images/loggedout/icons/apple_icon-22bf207f93e1e094c40feb3e2491ff98.png";